import MenuSuperior from "../Components/MenuSuperior"
import HeroStatic from "../Components/HeroStatic";
import Cards from "../Components/Equipe/cards";
import EquipeJesus from "../Components/EquipeJesus";
import Footer from "../Components/Footer";

const Index = () => {
    return (
        <div>
            <MenuSuperior />
            <HeroStatic title={'Nossa Equipe'} />
            <EquipeJesus />
            <div className="container-fluid team">
                <div className="container py-5">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Equipe UTI Neonatal</h4>
                        </div>
                    </div>
                    <Cards equipeCompleta={true} />
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default Index;